import React from 'react';
import PendingPayments from './PendingPayments/PendingPayments';
import PaymentsHistory from './PaymentsHistory/PaymentsHistory';

const AdminPayments = () => {
  return (
    <div className='flex flex-col w-full min-w-0 items-start gap-12 tabletV:gap-20'>
      <PendingPayments />
      <PaymentsHistory />
    </div>
  );
};

export default AdminPayments;
